import { useCallback, useEffect, useRef, useState } from 'react';

import lineEndpoint from '../../../../api/services/lineEndpoint';

export const useFetchLines = (request = { boOrdenarPorNuLinha: false }) => {
  const [loading, setLoading] = useState();
  const [lines, setLines] = useState([])
  const isMounted = useRef(true)


  const fetchAllLines = useCallback(async () => {
    setLoading(true);
    if (lines.length === 0) {
      try {
        const response = await lineEndpoint.getLines({  page: 0, size: 9999, request: request });
        if(response && response.status === 200) {
          if(isMounted.current) setLines(response.data.content)
        }
      } finally {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllLines().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllLines]);

  return {
    loading,
    lines,
  };
};